import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Card, Alert, Button, Spinner } from 'react-bootstrap';
import { authAPI } from '../utils/httpClient';
import { useI18n } from '../i18n';
import styled from 'styled-components';

const VerifyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: var(--background-secondary);
`;

const VerifyCard = styled(Card)`
  width: 100%;
  max-width: 450px;
  border-radius: 8px;
  box-shadow: var(--shadow);
  padding: 2rem;
  text-align: center;
`;

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');
  const { t } = useI18n();
  
  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setVerifying(false);
      setSuccess(false);
      setMessage(t('auth:verifyEmail.invalidToken'));
      return;
    }
    
    const verifyEmailToken = async () => {
      try {
        const response = await authAPI.verifyEmail(token);

        setVerifying(false);

        if (response.success) {
          setSuccess(true);
          setMessage(response.message || t('auth:verifyEmail.success'));
        } else {
          setSuccess(false);
          setMessage(response.message || t('auth:verifyEmail.error'));
        }
      } catch (error) {
        setVerifying(false);
        setSuccess(false);
        setMessage(error?.message || t('auth:verifyEmail.error'));
      }
    };
    
    verifyEmailToken();
  }, [searchParams]);
  
  const handleLogin = () => {
    navigate('/login');
  };
  
  return (
    <VerifyContainer>
      <Container>
        <VerifyCard>
          <h2 className="mb-4">{t('auth:verifyEmail.title')}</h2>
          
          {verifying ? (
            <div className="text-center">
              <Spinner animation="border" role="status" variant="primary" />
              <p className="mt-3">{t('auth:verifyEmail.verifying')}</p>
            </div>
          ) : (
            <>
              <Alert variant={success ? 'success' : 'danger'}>
                {message}
              </Alert>
              
              {success && (
                <Button 
                  variant="primary" 
                  onClick={handleLogin}
                  className="mt-3"
                >
                  {t('auth:verifyEmail.successGoLogin')}
                </Button>
              )}
              
              {!success && (
                <div className="mt-3">
                  <p>{t('auth:verifyEmail.help')}</p>
                </div>
              )}
            </>
          )}
        </VerifyCard>
      </Container>
    </VerifyContainer>
  );
};

export default VerifyEmail;
